import React from 'react';
import { v4 as uuid } from 'uuid';
import { PropertyType } from '../../../common';
import styles from './Games.module.scss';
import { gamesListMap } from './Games.const';
import { find } from 'lodash';
import { BulkSelect } from './components';
import { Button, CheckmarkGreen, CheckmarkGreenFull, DangerDashFill, Success, Switch, Tooltip } from 'esa-ui-library';

export const getRows = (
	games: PropertyType[],
	columns: PropertyType[],
	onAction: (a: string, game: PropertyType) => void,
	AAMS_types: PropertyType[] = []
): PropertyType[] => {
	const isItaly = process.env.REACT_APP_SITE_TITLE?.includes('Italy');
	const getActiveCells = (g: PropertyType): PropertyType[] => {
		const rows: PropertyType[] = [];
		columns.forEach((column) => {
			const field = find(gamesListMap, ['label', column.label])?.key;
			const aamsTypeLabel = isItaly
				? find(AAMS_types, (type) => `${type.value}` === `${g.aams_type_id}`)?.label
				: undefined;
			const cellsMap = {
				game_id: <span key={uuid()}>{g.internal_game_id}</span>,
				active: (
					<span key={uuid()}>
						{
							<Switch
								disabled
								checked={!!g.active}
								onChange={() => onAction('enable', g)}
								label={g.active ? 'Enabled' : 'Disabled'}
							/>
						}
					</span>
				),
				game_name: <span key={uuid()}>{g.game_name}</span>,
				provider_name: <span key={uuid()}>{g.game_provider_name}</span>,
				is_slot: (
					<span className={styles.DataIcon} key={uuid()}>
						{g.is_slot === 1 ? <CheckmarkGreen /> : ''}
					</span>
				),
				provider_game_id_desktop: <span key={uuid()}>{g.provider_game_id_desktop}</span>,
				aams_game_id_desktop: <span key={uuid()}>{g.aams_game_id_desktop}</span>,
				aams_game_id_type: <span key={uuid()}>{aamsTypeLabel || g.aams_game_id_type}</span>,
				checksum_result: (
					<span key={uuid()} className={styles.Status}>
						{g.checksum_result === 0 && <CheckmarkGreenFull />}
						{g.checksum_result > 0 && <DangerDashFill />}
					</span>
				),
				notes: (
					<span key={uuid()} className={styles.NoteIcon}>
						<Tooltip position='top' text={g.notes || ''}>
							{g.notes && <Success />}
						</Tooltip>
					</span>
				),
				actions: (
					<span key={uuid()} className={styles.BtnBox}>
						<Button onClick={() => onAction('edit', g)} title='Edit' small className={styles.Btn} />
						<Button onClick={() => onAction('category', g)} title='Category' small className={styles.Btn} />
						{!process.env.REACT_APP_SITE_TITLE?.includes('Italy') && (
							<Button onClick={() => onAction('partners', g)} title='Assign partners' small className={styles.Btn} />
						)}
						<Button onClick={() => onAction('showPartners', g)} title='Show Partners' small className={styles.Btn} />
					</span>
				),
			};
			if (field) {
				rows.push((cellsMap as Record<string, JSX.Element>)[field]);
			}
		});
		rows.unshift(<BulkSelect key={g.internal_game_id} id={`${g.internal_game_id}`} />);
		return rows;
	};

	if (!process.env.REACT_APP_SITE_TITLE?.includes('Italy')) {
		columns.pop();
	}

	const data = games.map((g) => getActiveCells(g));
	return data;
};
